import type { Notification } from '@workspace/lib/api/notification'
import { parseNotificationContent } from '@/shared/utils/notification.utils'

interface NotificationContentProps {
    notification: Notification
    /**
     * For approval notifications, highlight specific keywords with colors
     * - 'approved': "duyệt" → green
     * - 'rejected': "từ chối" → red
     */
    highlightApprovalStatus?: boolean
}

/**
 * Renders notification content with bold formatting for important parts
 * Reusable component for NotificationItem and NotificationToast
 */
export function NotificationContent({ notification, highlightApprovalStatus = false }: NotificationContentProps) {
    const parts = parseNotificationContent(notification, { highlightApprovalStatus })

    return (
        <>
            {parts.map(part => (
                <span key={part.key} className={part.className}>
                    {part.text}
                </span>
            ))}
        </>
    )
}
